<template lang="pug">
	.section.section--white
		.donation-technical-error
			VueFeedback(type="error")
				template(slot="feedback-title") Technikai hiba történt!
				template(slot="feedback-content")
					p Technikai hiba történt! Kérjük később próbálja újra!
</template>
<script>
import VueFeedback from '@ui-common/vue-feedback';
export default {
	components: {
		VueFeedback
	},
	mounted() {
		this.$scrollTo(this.$el);
	}
};
</script>
